@if (task().issueWasUpdated) {
  <mat-icon>update</mat-icon>
} @else {
  <mat-icon [svgIcon]="ISSUE_PROVIDER_ICON_MAP[task().issueType!]"></mat-icon>
}

<span>{{ ISSUE_PROVIDER_HUMANIZED[task().issueType!] }}</span>
